<template>
  <div tabindex="-1"  @keydown.stop.left="onKeyLeft" @keydown.stop.right="onKeyRight" class="line-detail elevation-0" >            
    <v-layout column>      
        <template v-if="mission._detailLoaded">              
          <div class="pb-2"  style="display:flex;">
            <mission-surfacage :mission="mission" />
            <v-spacer />
            <!-- BLF037 : rien de la flotte si elle est refusée pour son enseigne (RG-ACC-053) -->
            <v-btn v-if="!isFleet && mission.fleId && $store.getters.isFleetAllowed(adminFleetsById[mission.fleId])" :to="{name:'FleetDetail',params:{fleetid:mission.fleId}}" class="mt-0">{{adminFleetsById[mission.fleId].FLE_LIBELLE}}<v-icon right>mdi-google-circles-communities</v-icon></v-btn>
          </div>           
          <mission-range-time-line :uiid="uiid" v-if="showTimeRange && !isFleet" :mission="mission" :updateOnMove="isGlobal" />                   
          <mission-time-line :uiid="uiid" v-if="showTimeRange" :mission="mission" />                    
          <template v-if="yo && canRender">                           
            <div v-if="yo.isUnderWater">     
              <hr/>         
              <strong>{{$t('Pilot.MissionDrawer.Cycle')}} {{yo.yosCycle}} :</strong> {{$t('Pilot.MissionDrawer.UndewaterInfos')}} 
            </div>
            <div  v-else>
            <hr v-if="!isFleet"/>                
            <template v-if="!hasMrsNmea">
                <h2 class="body-2">{{$t('Pilot.MissionDrawer.MRS')}}</h2>
                <table class="mrs-tbl" cellspacing="0">
                  <thead>
                    <tr>          
                      <td>{{$t('Pilot.MissionDrawer.Cycle')}}</td>
                      <td>{{$t('Pilot.MissionDrawer.Battery')}}</td>          
                      <td>{{$t('Pilot.MissionDrawer.Date')}}</td>          
                      <td>{{$t('Pilot.MissionDrawer.Time')}}</td>
                      <td>{{$t('Pilot.MissionDrawer.Latitude')}}</td>
                      <td>{{$t('Pilot.MissionDrawer.Longitude')}}</td>
                    </tr>
                  </thead>
                  <tr>          
                      <td>{{yo.yosCycle}}</td>
                      <td>{{yo.batteries}} V</td>          
                      <td>{{yo.yoGpsDatTime | formatDate('DD/MM/YYYY')}}</td>
                      <td>{{yo.yoGpsDatTime | formatDate('HH:mm:ss UTC')}}</td>
                      <td>{{$options.filters[coordFormatFilter]([yo.yoGpsLon,yo.yoGpsLat],true)}}</td>
                      <td>{{$options.filters[coordFormatFilter]([yo.yoGpsLon,yo.yoGpsLat],false)}}</td>          
                    </tr>
                </table>   
              </template>
              <template v-if="!hasNavNmea">
                              <h2 class="body-2">{{$t('Pilot.MissionDrawer.Nav')}}</h2>  
              <table class="mrs-tbl" cellspacing="0">
                <thead>
                  <tr>          
                    <td>{{$t('Pilot.MissionDrawer.Heading')}} [°]</td>
                    <td>{{$t('Pilot.MissionDrawer.Zb')}} [m]</td>
                    <td>{{$t('Pilot.MissionDrawer.Zt')}} [m]</td>
                    <td>{{$t('Pilot.MissionDrawer.Altitude')}} [m]</td>
                    <td>{{$t('Pilot.MissionDrawer.PU')}} [mm]</td>
                    <td>{{$t('Pilot.MissionDrawer.PD')}} [mm]</td>
                    <td>{{$t('Pilot.MissionDrawer.BU')}} [ml]</td>
                    <td>{{$t('Pilot.MissionDrawer.BD')}} [ml]</td>
                    <td>{{$t('Pilot.MissionDrawer.Rate')}}</td>
                  </tr>
                </thead>
                <tr>
                    <td>{{yo.heading}}</td>
                    <td>{{yo.zb}}</td>
                    <td>{{yo.zt}}</td>
                    <td>{{yo.alt}}</td>
                    <td>{{yo.pu}}</td>
                    <td>{{yo.pd}}</td>
                    <td>{{yo.bu}}</td>
                    <td>{{yo.bd}}</td>
                    <td>{{yo.rate}}</td>          
                  </tr>
              </table> 
            </template>   
              <template v-if="!hasComputedNmea">
                <h2 class="body-2">{{$t('Pilot.MissionDrawer.Computed')}}</h2>
                <table class="mrs-tbl" cellspacing="0">
                  <thead>
                    <tr>          
                      <td>{{$t('Pilot.MissionDrawer.Distance')}} [m]</td>
                      <td>{{$t('Pilot.MissionDrawer.FlightTime')}} [h:m]</td>
                      <td>{{$t('Pilot.MissionDrawer.COG')}} [°]</td>
                      <td>{{$t('Pilot.MissionDrawer.SOG')}} [m/s]</td>
                      <td>{{$t('Pilot.MissionDrawer.Drift')}} [°]</td>                    
                      <td>{{$t('Pilot.MissionDrawer.MissionDuration')}}</td>
                    </tr>
                  </thead>
                  <tr>
                      <td>{{computedDistance}}</td>
                      <td>{{computedFlightTime}}</td>
                      <td>{{computedCog}}</td>
                      <td>{{computedSog}}</td>
                      <td>{{computedDrift}}</td>
                      <td>{{[mission.yoArray[0].yoGpsDatTime,yo.yoGpsDatTime] | formatDuree($i18n)}}</td>
                    </tr>
                </table>  
              </template>                     
              <template v-for="nmeaInit in nmeasInit">
                <div v-if="nmeaInit.name == 'computed'" :key="nmeaInit.name">
                  <h2 class="primary--text body-2" >{{$t('Pilot.MissionDrawer.Computed')}}</h2>                     
                  <table class="mrs-tbl" cellspacing="0"  v-if="nmeaInit.col1.length > 0">
                    <thead>
                      <tr>          
                        <td v-for="col in nmeaInit.col1" :key="`th_${col.name}`">{{$i18n.locale == 'fr'?col.libelleFr||col.libelleEn:col.libelleEn||col.libelleFr}} <template v-if="col.unit.length > 0">[{{col.unit}}]</template></td>            
                      </tr>
                    </thead>
                    <tr>          
                        <td v-for="col in nmeaInit.col1" :key="`td_${col.name}`">{{computedFromName(col.name)}}</td>        
                    </tr>
                  </table> 
                  <table class="mrs-tbl mt-1" cellspacing="0"  v-if="nmeaInit.col2.length > 0">
                    <thead>
                      <tr>          
                        <td v-for="col in nmeaInit.col2" :key="`th_${col.name}`">{{$i18n.locale == 'fr'?col.libelleFr||col.libelleEn:col.libelleEn||col.libelleFr}} <template v-if="col.unit.length > 0">[{{col.unit}}]</template></td>            
                      </tr>
                    </thead>
                    <tr>          
                        <td v-for="col in nmeaInit.col2" :key="`td_${col.name}`">{{computedFromName(col.name)}}</td>        
                    </tr>
                  </table> 
                  <table class="mrs-tbl mt-1" cellspacing="0"  v-if="nmeaInit.col3.length > 0">
                    <thead>
                      <tr>          
                        <td v-for="col in nmeaInit.col3" :key="`th_${col.name}`">{{$i18n.locale == 'fr'?col.libelleFr||col.libelleEn:col.libelleEn||col.libelleFr}} <template v-if="col.unit.length > 0">[{{col.unit}}]</template></td>            
                      </tr>
                    </thead>
                    <tr>          
                        <td v-for="col in nmeaInit.col3" :key="`td_${col.name}`">{{computedFromName(col.name)}}</td>        
                    </tr>
                  </table>                                 
                </div>
                <mission-nmea-detail v-else :mission="mission" :nmeaConfig="nmeaInit" :loading="!!nmeaLoading[nmeaInit.name]" :yoCycle="yoCycle" :yoIndex="yoIndex" :key="nmeaInit.name" />              
              </template>              
              <template v-if="nmeasLazy.length > 0">
                <div class="primary--text py-1 cursor-pointer" style="text-align:right"  @click.prevent="$store.myActions.UI_TOGGLE_MORE_NMEA_VISIBILITY(uiid)"><template v-if="showMoreNmea">{{$t('Pilot.MissionDrawer.MinusNmea')}} <v-icon small>mdi-minus</v-icon></template><template v-else>{{$t('Pilot.MissionDrawer.MoreNmea')}} <v-icon small>mdi-plus</v-icon></template></div>                
                <div v-if="showMoreNmea">                  
                  <mission-nmea-detail v-for="nmeaLazy in nmeasLazy" :mission="mission" :nmeaConfig="nmeaLazy" :loading="!!nmeaLoading[nmeaLazy.name]" :yoCycle="yoCycle" :yoIndex="yoIndex" :key="nmeaLazy.name" />              
                </div> 
              </template>             
            </div> 
          </template>
        </template>    
        <template  v-else>
          {{$t("Pilot.MissionDrawer.Loading")}}
          <v-progress-linear indeterminate color="primary" ></v-progress-linear>      
        </template>        
        <!--v-dialog v-if="mission.misActifOn" v-model="showClosMissionDialog" persistent max-width="600">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" v-on="on" >{{$t('End Mission')}}</v-btn>              
          </template>
          <v-card>
            <v-card-title class="headline">{{$t('Do you really want end mission?')}}</v-card-title>
            <v-card-text>La mission {{mission.misLibelle}} sera terminée et ne sera plus active</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat @click="showClosMissionDialog = false">{{$t('Annuler')}}</v-btn>
              <v-btn color="red darken-1" flat @click="showClosMissionDialog = false" >{{$t('End mission')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog-->          
      <div v-if="mission.hasEndMissionSimulation"  :style="isSimuNotApplicable?'background-color:#fca5a5;margin: 0 -20px 0 -20px;padding: 0 20px 0 20px;':''">            
        <div class="flex flex-wrap items-center pt-2 cursor-pointer"  @click.prevent="$store.myActions.UI_TOGGLE_REMAINING_NAV_VISIBILITY(uiid)" >              
          <h2 :title="$t('Pilot.MissionDrawer.HideEndMissionSimulation')"  v-if="showRemainingNavigation" class="secondary--text body-2 text-uppercase">{{ $t("Pilot.MissionDrawer.EndMissionSimulation") }} <span v-if="isSimuNotApplicable" style="text-transform: none;font-style: italic;">({{ $t("Pilot.MissionDrawer.EndMissionSimulationNotApplicable") }})</span> <v-icon small>mdi-minus</v-icon></h2>          
          <h2  v-else class="secondary--text body-2 text-uppercase" :title=" $t('Pilot.MissionDrawer.ShowEndMissionSimulation')" >{{ $t("Pilot.MissionDrawer.EndMissionSimulation") }} <span v-if="isSimuNotApplicable" style="text-transform: none;font-style: italic;">({{ $t("Pilot.MissionDrawer.EndMissionSimulationNotApplicable") }})</span> <v-icon small>mdi-plus</v-icon></h2>                    
        </div>
        <div class="grow-0 flex flex-col text-xs" v-if="showRemainingNavigation">                
            <simulation-mission-line-detail  class="mb-2 pb-2 pt-0" :mission="mission" :typeUiid="isGlobal?'global':'detail'" :endMissionMode="true" />                            
            <table class="mrs-tbl mb-2" cellspacing="0">
                <thead>
                  <tr>          
                    <td>{{$t("Simulation.ProcessingState")}}</td>
                    <td>{{$t("Simulation.ProcessingTime")}}</td>
                    <td>{{$t("Simulation.EstimatedMissionEndDate")}}</td>                         
                  </tr>
                </thead>
                <tr>
                    <td><span class="data">{{$t(getSimulationStatusTradKey(mission.vimStatus)) }}</span></td>
                    <td><span class="data" v-if="mission.result && mission.result.processing_time">{{  $options.filters.formatDuration(mission.result.processing_time * 1000,true) }}</span></td>
                    <td><span class="data" v-if="mission.result">{{ $options.filters.formatDate(mission.result.mission_end_date,"DD/MM/YYYY HH:mm") }}</span></td>
                  </tr>
              </table>                              
        </div>                
        </div>  
    </v-layout>        
  </div>    
</template>
<script>  
  import { mapGetters } from 'vuex'  
  import MissionTimeLine from '@/components/mission/MissionTimeLine'
  import MissionRangeTimeLine from '@/components/mission/MissionRangeTimeLine'  
  import MissionColor from '@/components/mission/MissionColor'  
  import { AloMission } from '@/models/alo/AloMission'  
  import {stylesList, defaultMapStyle} from '@/components/map/MapStyles'    
  import bearing from '@turf/bearing'
  import distance from '@turf/distance'
  import {point,bearingToAzimuth} from '@turf/helpers'
  import MissionSurfacage from '@/components/mission/MissionSurfacage'
  import SimulationMissionLineDetail from '@/components/smart/SimulationMissionLineDetail'
  import MissionNmeaDetail from '@/components/mission/MissionNmeaDetail'  
  import { SecurityItemsKeys } from '../../enum/SecurityItems'
  import {posModulo} from  '@/utils/modulo'
  import { NmeasConfig } from '@/models/datapool/NmeasConfig'
  import { DataPoolGlobalKeys } from '@/enum/DataPool'
  import {getSimulationStatusTradKey,SimulationStatus} from '@/enum/SimulationStatus'  
  import mission from '@/api/mission'
import { buildMissionPlanStateId } from '@/models/ui/MissionPlanUiState'

  export default {
    name: 'MissionLineDetail',
    props:{
      mission:{
        type: AloMission
      },
      uiid:{
          type: String,
          required: true
      },
      showTimeRange:{
        type: Boolean,
        default: true
      },
      shownav:{
          type: Boolean,
          default: false
      }
    },
    data(){
      return {
        showClosMissionDialog:false,        
        nmeasConfig: new NmeasConfig(),
        nmeaLoading:{},
        canRender:true
      }
    },   
    components:{SimulationMissionLineDetail,MissionTimeLine,MissionRangeTimeLine,MissionSurfacage,MissionColor,MissionNmeaDetail},          
    created(){
      this.$options.stylesList = stylesList
      this.$options.defaultMapStyle = defaultMapStyle     
      
      this.$store.myActions.DATAPOOL_ENSURE({fullKey:DataPoolGlobalKeys['global.config.nmea']}).then(()=>{
        this.nmeasConfig = NmeasConfig.createNmeasConfig(this.originalNmeaConfigStr)          
      })            
    },    
    mounted(){
      if(this.mission.hasEndMissionSimulation) {
        this.$store.myActions.MISSION_ENSURE_MISSION_PLAN(this.mission.misId) 
      }
      this.checkSimulationProgress();      
      ["seadrk","seamrs","seanav"].forEach(nmea => {
        this.$set(this.nmeaLoading,nmea,true)
        this.$store.myActions.MISSION_ENSURE_DATA_NMEA({typeNmea:nmea,id:this.mission.misId}).finally(()=>{
          this.nmeaLoading[nmea] = false
        })
      })
    
      setTimeout(() => {
        this.ensureLazyNmeas()
      }, 500);            
    },
    computed:{
      ...mapGetters([
        'uistatebyuiid',            
        'coordFormatFilter',
        'adminFleetsById',
        'currentMissionMapId'
      ]),   
      missionStartDate()  {
        return this.mission?.param?.mission_start_date
      },      
      missionCurEndDate()  {
        return (this.mission?.result?.mission_end_date?.length ?? 0) > 0?this.mission?.result?.mission_end_date:this.mission?.result?.current_date
      },  
      energy_available(){
        return this.mission?.result?.energy_available ?? this.mission?.result?.current_battery
      },
      nbYos(){
        return this.mission?.result?.cycle_number ?? this.mission?.result?.current_cycle
      },
      showError(){
        return (this.mission?.result?.error_msg?.length ?? 0) > 0
      },
      isSimuNotApplicable(){
        return (this.mission.vimStatus == 10 || (this.mission?.result?.error_msg?.startsWith('Battery limit'))) && this.missionPlanDatPub >  this.mission?.vimDatexec
      },
      getSimulationStatusTradKey()
      {
        return getSimulationStatusTradKey
      },
      missionState() {          
        //retourne un MissionUiState            
        return this.uistatebyuiid(this.uiid)
      },
      missionPlanUiid() {
        return buildMissionPlanStateId(this.mission.misId || -1,"mission")
      },
      missionPlanUiState(){
        return this.$store.myGetters.uistatebyuiid(this.missionPlanUiid)
      },
      missionPlanDatPub() { 
        //on ajoute 5 s car des fois soucis de temps de sauvegarde entre date mission plan et date de simulation
        return this.missionPlanUiState?.missionPlan?.dat_pub?new Date(new Date(this.missionPlanUiState?.missionPlan?.dat_pub).getTime() + 5000):null
      },
      hasComputedNmea()
      {
        return (this.nmeasInit?.findIndex(r => r.name.toLowerCase() == "computed") ?? -1)  > -1
      },
      hasMrsNmea()
      {
        return (this.nmeasInit?.findIndex(r => r.name.toLowerCase() == "seamrs") ?? -1)  > -1
      },
      hasNavNmea()
      {
        return (this.nmeasInit?.findIndex(r => r.name.toLowerCase() == "seanav") ?? -1)  > -1
      },
      isFleet() {
        return this.missionState?.typeUiid == 'fleet'
      },     
      isGlobal() {
        return this.missionState?.typeUiid == 'global'
      },                           
      yo(){           
        return this.mission.yoArray[this.yoIndex]
      },
      yoCycle(){           
        return this.mission.yoArray[this.yoIndex]?.yosCycle
      },
      yoIndex(){
        return this.missionState && this.missionState.timelineIndex != -1?this.missionState.timelineIndex:(this.mission.yoArray.length-1)
      },
      nextYo() {            
        let yo = null        
        if(this.missionState && this.missionState.timelineIndex != -1) {
          let idx = 1
          while(this.mission.yoArray.length > (this.missionState.timelineIndex+idx) &&  (yo = this.mission.yoArray[this.missionState.timelineIndex+idx]).isUnderWater){
            idx++;
          }        
          if(yo && !yo.isUnderWater) return yo.driftArray[0] || yo          
        }
        return null
      },
      canComputeCoord(){
        return this.nextYo && this.nextYo.yoGpsLon && this.nextYo.yoGpsLat && this.yo && this.yo.yoGpsLon && this.yo.yoGpsLat
      },
      computedDistance() {        
        if(this.canComputeCoord) {             
          return (distance(point([this.yo.yoGpsLon, this.yo.yoGpsLat]),point([this.nextYo.yoGpsLon, this.nextYo.yoGpsLat])) * 1000).toFixed(0)
        }
        else{
          return '-'
        }
      },
      computedFlightTime() {                
        if(this.nextYo) {             
          return this.$options.filters.formatDuree([this.yo.yoGpsDatTime,this.nextYo.yoGpsDatTime],this.$i18n)
        }
        else{
          return '-'
        }
      },
      computedCog(){
        if(this.canComputeCoord) {
          return bearingToAzimuth(bearing(point([this.yo.yoGpsLon, this.yo.yoGpsLat]),point([this.nextYo.yoGpsLon, this.nextYo.yoGpsLat]))).toFixed(2)
        }
        else{
          return '-'
        }
      },
      computedDrift() {
        if(this.canComputeCoord && this.yo.heading != -9999) {          
          return (posModulo( this.computedCog -  this.yo.heading + 180,360) - 180).toFixed(2)
        }
        else{
          return '-'
        }
      },
      computedSog(){
        if(this.canComputeCoord) {
          return (this.computedDistance / ((this.nextYo.yoGpsDatTime.getTime() -  this.yo.yoGpsDatTime.getTime())/1000)).toFixed(2)
        }
        else{
          return '-'
        }
      },
      showMoreNmea(){
        return this.missionState.showMoreNmea
      },
      showRemainingNavigation(){
        return this.missionState.showRemainingNavigation
      },
      originalNmeaConfigStr() {        
        return  (this.$store.myGetters.dataPoolItemsValueByKey(DataPoolGlobalKeys['global.config.nmea']) || "").split('\n')
      },
      nmeasInit(){
        return this.nmeasConfig.rowInit.filter(r => r.name.toLowerCase() == "computed" || this.mission.nmeaTypeArray.findIndex(n => r.name.toLowerCase() == n.toLowerCase()) > -1)
      },
      nmeasLazy(){
        return this.nmeasConfig.rowLazy.filter(r => r.name.toLowerCase() == "computed" || this.mission.nmeaTypeArray.findIndex(n => r.name.toLowerCase() == n.toLowerCase()) > -1)
      },
      missionRefresh(){
        return this.mission._refresh
      }      
    },    
    watch:{
      originalNmeaConfigStr(newValue) {
        this.nmeasConfig = NmeasConfig.createNmeasConfig(this.originalNmeaConfigStr)
      },
      nmeasInit(newValues){
        //requetes les données de chacune des nmea a affiché en init si non chargées
        newValues.forEach(c => {
          if(c.name != 'computed'){
            this.$set(this.nmeaLoading,c.name,true)
            this.$store.myActions.MISSION_ENSURE_DATA_NMEA({typeNmea:c.name,id:this.mission.misId}).finally(()=>{
              this.nmeaLoading[c.name] = false
            })
          }
        })
        
      },
      showMoreNmea(newValues) {
        this.ensureLazyNmeas()
      },
      missionRefresh() {        
        this.canRender = false
        this.$nextTick(()=> this.canRender = true)
      },
      uiid(){
        this.checkSimulationProgress()
      }
    },
    methods:{
      checkSimulationProgress(){
        if(this.mission.hasEndMissionSimulation) {
          if(!(this.mission.simulation?._detailLoaded ?? false)) {
            this.$store.myActions.MISSIONVIRTUAL_PROGRESSION_REQUEST(this.mission.misId)
          }
        }
      },
      ensureLazyNmeas() {
        if(this.showMoreNmea){
          //requetes les données de chacune des nmea a affiché en lazy si non chargées
          this.nmeasLazy.forEach(c => {            
            if(c.name != 'computed'){
              this.$set(this.nmeaLoading,c.name,true)
              this.$store.myActions.MISSION_ENSURE_DATA_NMEA({typeNmea:c.name,id:this.mission.misId}).finally(()=>{
                this.nmeaLoading[c.name] = false
              })
            }
          })     
        }
      },
      computedFromName(name){
        switch(name){
          case "distance": return this.computedDistance
          case "flight_time": return this.computedFlightTime
          case "cog": return this.computedCog
          case "sog": return this.computedSog
          case "drift": return this.computedDrift
          case "mission_duration":{            
            const firstDate = this.mission.yoArray?.find(y => !!y.yoGpsDatTime && y.yoGpsDatTime.toString() != 'Invalid Date')?.yoGpsDatTime                
            return this.$options.filters.formatDuree([firstDate,this.yo.yoGpsDatTime],this.$i18n)
          } 
          default: return "-"          
        }
      },
      onKeyRight(){                                      
        const index = this.missionState.timelineIndex != -1? this.missionState.timelineIndex : this.mission.yoArray.length - 1
        if(index < (this.mission.yoArray.length - 1)) {            
          this.$store.myActions.UI_SELECT_TIMELINE_MISSION_INDEX({index:index+1, uiid:this.uiid})                                  
        }        
      },
      onKeyLeft(){                
        const index = this.missionState.timelineIndex != -1? this.missionState.timelineIndex : this.mission.yoArray.length - 1
        if(index > 0) {            
          this.$store.myActions.UI_SELECT_TIMELINE_MISSION_INDEX({index:index-1, uiid:this.uiid})                                  
        }        
      },
      endMission() {
        
      }    
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2{
  color: var(--primary-color)  
}
</style>
<style>

.mrs-tbl{
  width: 100%;
  font-size: 0.8rem;
}

.cursor-pointer{
  cursor: pointer;
}

table{
  border: 1px solid #ddd;
  border-bottom:0px;
  border-right:0px;    
  max-width: 100%; 
  overflow: auto;
}
thead{
  font-weight: bold;
}
td{
  padding: 0px 2px;
  border:1px solid #ddd;
  border-top:0px;
  border-left:0px;  
  text-align: center;
} 


.line-item .active{
  color: #4caf50!important;
}

.line-item .heading{
  display: flex;
  flex-direction: row;
  align-items: center;  
}
.White>div{
  border: solid 2px #000!important;
}

.line-detail:focus{
    outline: none;
}

.line-detail{
  /*correct elevation bug*/
  -webkit-box-shadow: 0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12)!important;
  box-shadow: 0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12)!important;
}
</style>
